import { render, staticRenderFns } from "./documents.valueAddedTaxPP54.vue?vue&type=template&id=daa09a4c&scoped=true"
import script from "./documents.valueAddedTaxPP54.vue?vue&type=script&lang=js"
export * from "./documents.valueAddedTaxPP54.vue?vue&type=script&lang=js"
import style0 from "./documents.valueAddedTaxPP54.vue?vue&type=style&index=0&id=daa09a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa09a4c",
  null
  
)

export default component.exports